module.exports = __webpack_public_path__ + "media/components/onboarding/icons/powered-by-icon-8ed43a3cdde3ac33676f584a602e0baf.png";